import { render, staticRenderFns } from "./CInvestigationPlan.vue?vue&type=template&id=0d099d50"
import script from "./CInvestigationPlan.vue?vue&type=script&lang=js"
export * from "./CInvestigationPlan.vue?vue&type=script&lang=js"
import style0 from "./CInvestigationPlan.vue?vue&type=style&index=0&id=0d099d50&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d099d50')) {
      api.createRecord('0d099d50', component.options)
    } else {
      api.reload('0d099d50', component.options)
    }
    module.hot.accept("./CInvestigationPlan.vue?vue&type=template&id=0d099d50", function () {
      api.rerender('0d099d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CInvestigationPlan.vue"
export default component.exports